import { ChannelConnectResponse, ChannelCredentialStatus, ChannelOrderList, ChannelOrderSummary, ChannelQueuedResponse, } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchChannelCredentials = async (channelId, signal) => ChannelCredentialStatus.parse(await request(`/api/v1/channels/${channelId}/credentials`, { signal }));
export const saveChannelApplication = async (channelId, input) => {
    await request(`/api/v1/channels/${channelId}/credentials`, {
        method: 'PUT',
        body: input,
    });
};
/** Returns where to send the person; the screen opens it. */
export const startChannelConnect = async (channelId) => ChannelConnectResponse.parse(await request(`/api/v1/channels/${channelId}/connect`, { method: 'POST' }));
/**
 * Enfileira a publicação de estoque (F109).
 *
 * Deixou de devolver quantos anúncios foram atualizados porque deixou de
 * publicar dentro da requisição. O resultado por anúncio aparece na tabela de
 * Canais — `last_synced_at` e o erro, por linha — em vez de numa frase que
 * some quando a tela recarrega.
 */
export const syncChannelStock = async (channelId) => ChannelQueuedResponse.parse(await request(`/api/v1/channels/${channelId}/sync`, { method: 'POST' }));
export const fetchChannelOrders = async (query = {}, signal) => {
    const params = new URLSearchParams();
    if (query.status !== undefined)
        params.set('status', query.status);
    if (query.channelId !== undefined)
        params.set('channelId', query.channelId);
    const encoded = params.toString();
    return ChannelOrderList.parse(await request(`/api/v1/channels/orders${encoded.length > 0 ? `?${encoded}` : ''}`, { signal }));
};
export const acceptChannelOrder = async (orderId) => ChannelOrderSummary.parse(await request(`/api/v1/channels/orders/${orderId}/accept`, {
    method: 'POST',
}));
/**
 * A rede de proteção embaixo do webhook: pedir os pedidos recentes agora.
 *
 * Desde a F109 ela também roda sozinha a cada dez minutos; o botão continua
 * existindo porque "acabei de consertar a conta, traga agora" é um pedido
 * legítimo que ninguém quer esperar dez minutos para atender.
 */
export const fetchChannelOrdersFromMarketplace = async (channelId) => ChannelQueuedResponse.parse(await request(`/api/v1/channels/${channelId}/orders/fetch`, {
    method: 'POST',
}));
//# sourceMappingURL=channels-mercadolivre.js.map